import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const PREFIXO_TITULO = '[TESTE] ';

/**
 * Empresa de teste (990, que fica em produção só para simulações de Administrador/Admin Clínico): o mais evidente possível,
 * para ninguém confundir com a clínica real. Três sinais: faixa listrada fixa no topo, moldura vermelha ao redor da tela
 * e "[TESTE]" na aba do navegador. Só aparece quando o back diz que a sessão está na empresa de teste.
 * Back: docs/empresa-teste-producao.md.
 */
export default function FaixaEmpresaTeste() {
  const { empresaTeste, empresaId } = useAuth();

  useEffect(() => {
    if (!empresaTeste) return undefined;
    const original = document.title;
    if (!original.startsWith(PREFIXO_TITULO)) document.title = `${PREFIXO_TITULO}${original}`;
    return () => { document.title = original.startsWith(PREFIXO_TITULO) ? original.slice(PREFIXO_TITULO.length) : original; };
  }, [empresaTeste]);

  if (!empresaTeste) return null;
  return (
    <>
      <Box
        role="alert"
        data-testid="faixa-empresa-teste"
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: (t) => t.zIndex.tooltip + 1,
          textAlign: 'center',
          py: { xs: 0.5, sm: 0.75 },
          px: 1,
          color: '#fff',
          background: 'repeating-linear-gradient(-45deg, #b71c1c, #b71c1c 16px, #7f0000 16px, #7f0000 32px)',
          borderBottom: '3px solid #ffeb3b',
        }}
      >
        <Typography component="span" sx={{ fontWeight: 900, letterSpacing: { xs: 1, sm: 3 }, fontSize: { xs: '0.8rem', sm: '1.1rem' }, textShadow: '0 1px 2px rgba(0,0,0,.7)' }}>
          ⚠ EMPRESA DE TESTE{empresaId ? ` (${empresaId})` : ''} — nada aqui é de paciente real ⚠
        </Typography>
      </Box>
      <Box
        aria-hidden
        data-testid="moldura-empresa-teste"
        sx={{ position: 'fixed', inset: 0, pointerEvents: 'none', border: '6px solid #b71c1c', zIndex: (t) => t.zIndex.tooltip }}
      />
    </>
  );
}
